module.exports = __webpack_public_path__ + "static/media/mw.746101c1.webp";